import React from 'react';
import SubTable from 'src/components/commons/subTable';
import PageContainer from 'src/components/pageContainer/PageContainer';

import StyleInfinityScroll from '../../../subTables/styles/StyleInfinityScroll.style';
import useCustomFieldsTable from './hooks/useCustomFieldsTable';

const TabCustomFieldsTable = () => {
  const {
    autocompleteFieldSearch,
    handleFilterChange,
    handleSortModelChange,
    setColumns,
    columns,
    newRecord,
    postData,
    createNewRecord,
    handleUpdateRows,
    onListRender,
    resetNewRecord,
    dataSource,
    handleClearFilter,
    handleDeleteRows,
    dataModule,
    filterByModule,
  } = useCustomFieldsTable();

  return (
    <PageContainer margin='2rem'>
      <StyleInfinityScroll>
        <SubTable
          data={dataSource || []}
          onListRender={onListRender}
          columns={columns}
          setColumns={setColumns}
          autocompleteFieldProvider={autocompleteFieldSearch}
          onFilterChange={handleFilterChange}
          onSortChange={handleSortModelChange}
          scroll={{ y: '60vh', x: '90vw' }}
          actionCell={['delete']}
          headerActions={['filter']}
          id='application-settings-custom-types'
          showOptionFilterLeft={false}
          allowGlobalEditActive
          total
          showAutoIncrement
          handleUpdateRows={handleUpdateRows}
          onDeleteClick={handleDeleteRows}
          newRecord={newRecord}
          postData={postData}
          saveNewRecord={createNewRecord}
          resetNewRecord={resetNewRecord}
          clearFilter={handleClearFilter}
          nonGlobalFilterable
          nonEditable
          nonFilterable={false}
          showHeaderSelect
          dataForListInHeader={dataModule}
          filterByHeaderListClient={filterByModule}
          columnFilterShown
        />
      </StyleInfinityScroll>
    </PageContainer>
  );
};
export default TabCustomFieldsTable;
